import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react";
import CancelButton from "../Button/CancelButton";
import SaveButton from "../Button/SaveButton";

export default function SecondLanguage({ isOpen, onClose, onSave }) {
  const [language, setLanguage] = useState("en"); // default
  const {t} = useTranslation();
  // Load saved value
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("second_language"));
    if (stored?.language) {
      setLanguage(stored.language);
    }
  }, [isOpen]);

  const handleSave = () => {
    const data = { language };

    localStorage.setItem("second_language", JSON.stringify(data));
    onSave(data);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/15 flex justify-center items-center z-50">
      <div className="bg-white p-2 rounded shadow-lg w-80">
        <div className=" font-semibold bg-theme-headerBg rounded-1 px-2 py-[2px] text-theme-color mb-2">
         {t("chooseLanguageForTranslation")}
        </div>

        <div className="px-2 py-2">
          <label className="flex items-center gap-2 mb-2">
            <input
              type="radio"
              name="language"
              className="accent-theme-headerBg"
              value="en"
              checked={language === "en"}
              onChange={(e) => setLanguage(e.target.value)}
            />
           {t("english")}
          </label>

          <label className="flex items-center gap-2 mb-2">
            <input
              type="radio"
              name="language"
              className="accent-theme-headerBg"
              value="hi"
              checked={language === "hi"}
              onChange={(e) => setLanguage(e.target.value)}
            />
            {t("hindi")}
          </label>

          {/* <label className="flex items-center gap-2">
            <input
              type="radio"
              name="language"
              className="accent-theme-headerBg"
              value="pa"
              checked={language === "pa"}
              onChange={(e) => setLanguage(e.target.value)}
            />
            Punjabi
          </label> */}
        </div>

        <div className="flex justify-end gap-3">
          <CancelButton onClick={onClose} text="Cancel" />
          <SaveButton onClick={handleSave} text="Save" />
        </div>
      </div>
    </div>
  );
}
